// Newspaper-style ad placeholder — clearly marked "विज्ञापन"
export default function AdSlot({ variant = "banner", label = "विज्ञापन", testid = "ad-slot" }) {
  const sizes = {
    banner: "h-[90px] md:h-[110px]",
    leaderboard: "h-[100px] md:h-[130px]",
    square: "aspect-square",
    tall: "aspect-[3/4]",
  };
  return (
    <div
      data-testid={testid}
      className={`w-full ${sizes[variant] || sizes.banner} border border-dashed border-[#0F0F0F]/30 bg-white/50 relative overflow-hidden flex items-center justify-center`}
    >
      <div className="absolute top-2 left-3 font-sans-dev text-[10px] uppercase tracking-[0.28em] text-[#0F0F0F]/60">
        {label}
      </div>
      <div className="font-serif-dev italic text-[#0F0F0F]/40 text-sm md:text-base">
        Advertisement · 728 × 90
      </div>
      <div className="absolute bottom-2 right-3 font-sans-dev text-[9px] uppercase tracking-[0.24em] text-[#0F0F0F]/40">
        AD SLOT
      </div>
    </div>
  );
}
